// import React, { useState, useEffect, useMemo, useCallback } from "react";
// import { Title, Loading, useNotify, useQuery, Error } from "react-admin";
// import { Grid, Card, CardContent, Typography, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Checkbox, FormControlLabel, List, ListItem, ListItemIcon, ListItemText, Tabs, Tab, Box, Paper, LinearProgress, makeStyles, useTheme, useMediaQuery } from "@material-ui/core";
// import FilterListIcon from "@material-ui/icons/FilterList";
// import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, BarChart, Bar } from "recharts";
// import { differenceInCalendarDays, parseISO, format } from "date-fns";
// import { httpClient } from "../api/dataProvider"; // UPDATE THIS PATH if needed
// import { baseiUrl } from "../utils/constants"; // UPDATE THIS PATH if needed

// // STYLING
// const useStyles = makeStyles(theme => ({
//     root: {
//         padding: theme.spacing(2),
//     },
//     kpiCard: {
//         height: "100%",
//     },
//     kpiTitle: {
//         color: theme.palette.text.secondary,
//     },
//     kpiValue: {
//         fontWeight: "bold",
//     },
//     kpiChangePositive: {
//         color: theme.palette.success.main,
//     },
//     kpiChangeNegative: {
//         color: theme.palette.error.main,
//     },
//     chartContainer: {
//         height: 300,
//     },
//     mobileTab: {
//         fontSize: "0.5rem",
//         minWidth: "auto",
//         maxWidth: "100%",
//         // padding: theme.spacing(1, 2),
//     },
//     tabPanel: {
//         padding: props => (props.isSmall ? theme.spacing(1) : theme.spacing(2)),
//     },
//     vehicleListItem: {
//         marginBottom: theme.spacing(2),
//     },
//     violationsCard: {
//         textAlign: "center",
//         padding: theme.spacing(3),
//     },
//     violationValue: {
//         fontWeight: "bold",
//         marginTop: theme.spacing(1),
//     },
// }));

// // UTILITY FUNCTIONS
// const formatNumber = (num = 0, digits = 1) => num.toLocaleString(undefined, { minimumFractionDigits: digits, maximumFractionDigits: digits });
// const formatDuration = (totalMinutes = 0) => {
//     if (isNaN(totalMinutes) || totalMinutes <= 0) return "0m";
//     const h = Math.floor(totalMinutes / 60);
//     const m = Math.round(totalMinutes % 60);
//     return `${h > 0 ? `${h}h ` : ""}${m > 0 ? `${m}m` : ""}`.trim() || "0m";
// };
// const getInitialState = (key, dv) => {
//     try {
//         const i = localStorage.getItem(`tether_report_${key}`);
//         return i ? JSON.parse(i) : dv;
//     } catch (e) {
//         return dv;
//     }
// };
// const setStateInStorage = (key, v) => {
//     try {
//         localStorage.setItem(`tether_report_${key}`, JSON.stringify(v));
//     } catch (e) {}
// };

// // CHILD COMPONENTS
// const ReportFilterDialog = ({ open, onClose, onApply, allVehicles, initialFilters }) => {
//     const [days, setDays] = useState(initialFilters.days);
//     const [isAllSelected, setAllSelected] = useState(initialFilters.isAllSelected);
//     const [selectedPlates, setSelectedPlates] = useState(initialFilters.selectedPlates);

//     useEffect(() => {
//         if (open) {
//             setDays(initialFilters.days);
//             setAllSelected(initialFilters.isAllSelected);
//             setSelectedPlates(initialFilters.selectedPlates);
//         }
//     }, [initialFilters, open]);

//     const handleToggleVehicle = plate => setSelectedPlates(p => (p.includes(plate) ? p.filter(i => i !== plate) : [...p, plate]));
//     const handleApply = () => {
//         onApply({ days: parseInt(days, 10) || 7, isAllSelected, selectedPlates });
//         onClose();
//     };

//     const handleDaysChange = event => {
//         const value = event.target.value;
//         // Allow empty string so the user can clear the field
//         if (value === "") {
//             setDays(value);
//             return;
//         }

//         const numValue = parseInt(value, 10);
//         // Only update state if the number is within the valid range
//         if (!isNaN(numValue) && numValue >= 1 && numValue <= 365) {
//             setDays(numValue);
//         }
//     };

//     return (
//         <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
//             <DialogTitle>Filter Report</DialogTitle>
//             <DialogContent>
//                 <TextField autoFocus margin="dense" label="Number of Days" type="number" fullWidth value={days} onChange={handleDaysChange} inputProps={{ min: 1, max: 365 }} />
//                 <FormControlLabel control={<Checkbox checked={isAllSelected} onChange={e => setAllSelected(e.target.checked)} />} label="All Vehicles" />
//                 {!isAllSelected && (
//                     <Paper variant="outlined" style={{ maxHeight: 300, overflow: "auto" }}>
//                         <List dense>
//                             {(allVehicles || []).map(v => (
//                                 <ListItem key={v.id} button onClick={() => handleToggleVehicle(v.plate)}>
//                                     <ListItemIcon>
//                                         <Checkbox edge="start" checked={selectedPlates.includes(v.plate)} tabIndex={-1} />
//                                     </ListItemIcon>
//                                     <ListItemText primary={v.plate} secondary={v.tag || ""} />
//                                 </ListItem>
//                             ))}
//                         </List>
//                     </Paper>
//                 )}
//             </DialogContent>
//             <DialogActions>
//                 <Button onClick={onClose}>Cancel</Button>
//                 <Button onClick={handleApply} color="primary" variant="contained">
//                     Go
//                 </Button>
//             </DialogActions>
//         </Dialog>
//     );
// };

// const OverviewTab = ({ data, isSmall }) => {
//     const classes = useStyles();
//     const theme = useTheme();

//     // Calculate chart data for all charts at once, ensuring robustness against null/undefined values.
//     const chartData = useMemo(() => {
//         if (!data) return [];
//         const validData = data.filter(r => r && r.logDay); // Ensure data point and logDay exist

//         return validData
//             .sort((a, b) => new Date(a.logDay) - new Date(b.logDay))
//             .map(r => {
//                 try {
//                     return {
//                         name: format(parseISO(r.logDay), isSmall ? "M/d" : "MMM d"),
//                         "Distance (km)": parseFloat(((r.mileageInMeters || 0) / 1000).toFixed(1)),
//                         "Idle (hr)": (r.idlingInMinutes || 0) / 60,
//                         "Driven (hr)": (r.movingInMinutes || 0) / 60,
//                         "Speed Violations": (r.ownerSpeedViolations || 0) + (r.driverSpeedViolations || 0),
//                         "Fence Violations": (r.ownerFenceViolations || 0) + (r.driverFenceViolations || 0),
//                     };
//                 } catch (error) {
//                     // This will skip any entries with an invalid date format
//                     return null;
//                 }
//             })
//             .filter(Boolean); // Remove any null entries that failed to parse
//     }, [data, isSmall]);

//     return (
//         <Grid container spacing={4}>
//             {/* 1. Daily Mileage Chart */}
//             <Grid item xs={12} md={6}>
//                 <Typography variant="h6" gutterBottom align="center">
//                     Daily Mileage (km)
//                 </Typography>
//                 <div className={classes.chartContainer}>
//                     <ResponsiveContainer>
//                         <LineChart data={chartData} margin={{ top: 5, right: 20, left: -10, bottom: 5 }}>
//                             <CartesianGrid strokeDasharray="3 3" />
//                             <XAxis dataKey="name" tick={{ fontSize: isSmall ? 10 : 12 }} />
//                             <YAxis tick={{ fontSize: isSmall ? 10 : 12 }} />
//                             <Tooltip formatter={value => [`${value} km`, null]} />
//                             <Legend />
//                             <Line type="monotone" dataKey="Distance (km)" stroke={theme.palette.primary.main} strokeWidth={2} />
//                         </LineChart>
//                     </ResponsiveContainer>
//                 </div>
//             </Grid>

//             {/* 2. Idle vs. Driven Time Chart */}
//             <Grid item xs={12} md={6}>
//                 <Typography variant="h6" gutterBottom align="center">
//                     Idle vs. Driven Time (Hours)
//                 </Typography>
//                 <div className={classes.chartContainer}>
//                     <ResponsiveContainer>
//                         <BarChart data={chartData} margin={{ top: 5, right: 20, left: -10, bottom: 5 }}>
//                             <CartesianGrid strokeDasharray="3 3" />
//                             <XAxis dataKey="name" tick={{ fontSize: isSmall ? 10 : 12 }} />
//                             <YAxis tick={{ fontSize: isSmall ? 10 : 12 }} tickFormatter={value => `${Math.round(value)}h`} />
//                             <Tooltip formatter={(value, name) => [`${parseFloat(value).toFixed(1)}h`, name]} />
//                             <Legend />
//                             <Bar dataKey="Idle (hr)" fill={theme.palette.secondary.light} />
//                             <Bar dataKey="Driven (hr)" fill={theme.palette.success.light} />
//                         </BarChart>
//                     </ResponsiveContainer>
//                 </div>
//             </Grid>

//             {/* 3. Speed Violations Chart */}
//             <Grid item xs={12} md={6}>
//                 <Typography variant="h6" gutterBottom align="center">
//                     Speed Violations
//                 </Typography>
//                 <div className={classes.chartContainer}>
//                     <ResponsiveContainer>
//                         <BarChart data={chartData} margin={{ top: 5, right: 20, left: -10, bottom: 5 }}>
//                             <CartesianGrid strokeDasharray="3 3" />
//                             <XAxis dataKey="name" tick={{ fontSize: isSmall ? 10 : 12 }} />
//                             <YAxis allowDecimals={false} tick={{ fontSize: isSmall ? 10 : 12 }} />
//                             <Tooltip />
//                             <Legend />
//                             <Bar dataKey="Speed Violations" fill={theme.palette.error.main} />
//                         </BarChart>
//                     </ResponsiveContainer>
//                 </div>
//             </Grid>

//             {/* 4. Fence Violations Chart */}
//             <Grid item xs={12} md={6}>
//                 <Typography variant="h6" gutterBottom align="center">
//                     Fence Violations
//                 </Typography>
//                 <div className={classes.chartContainer}>
//                     <ResponsiveContainer>
//                         <BarChart data={chartData} margin={{ top: 5, right: 20, left: -10, bottom: 5 }}>
//                             <CartesianGrid strokeDasharray="3 3" />
//                             <XAxis dataKey="name" tick={{ fontSize: isSmall ? 10 : 12 }} />
//                             <YAxis allowDecimals={false} tick={{ fontSize: isSmall ? 10 : 12 }} />
//                             <Tooltip />
//                             <Legend />
//                             <Bar dataKey="Fence Violations" fill={theme.palette.warning.main} />
//                         </BarChart>
//                     </ResponsiveContainer>
//                 </div>
//             </Grid>
//         </Grid>
//     );
// };

// const VehiclesTab = ({ data }) => {
//     const classes = useStyles();
//     if (!data || data.length === 0) return <Typography>No vehicle data to display.</Typography>;
//     return (
//         <Grid container spacing={2}>
//             {data.map(vehicle => {
//                 const totalMileage = vehicle.report.reduce((s, r) => s + r.mileageInMeters, 0) / 1000;
//                 const totalMoving = vehicle.report.reduce((s, r) => s + r.movingInMinutes, 0);
//                 const totalIdling = vehicle.report.reduce((s, r) => s + r.idlingInMinutes, 0);
//                 const avgSpeed = vehicle.report.length > 0 ? vehicle.report.reduce((s, r) => s + r.avgSpeedInKmPh, 0) / vehicle.report.length : 0;
//                 const totalViolations = vehicle.report.reduce((s, r) => s + r.ownerParkViolations + r.ownerFenceViolations + r.ownerSpeedViolations + r.driverParkViolations + r.driverFenceViolations + r.driverSpeedViolations, 0);
//                 return (
//                     <Grid item xs={12} sm={6} md={4} key={vehicle.id}>
//                         <Card className={classes.vehicleListItem}>
//                             <CardContent>
//                                 <Typography variant="h6">{vehicle.plate}</Typography>
//                                 <Typography color="textSecondary" gutterBottom>
//                                     {vehicle.tag || `${vehicle.brand || ""} ${vehicle.model || ""}`}
//                                 </Typography>
//                                 <Box mt={2}>
//                                     <Grid container spacing={1}>
//                                         <Grid item xs={6}>
//                                             <Typography>
//                                                 <b>Distance:</b> {formatNumber(totalMileage)} km
//                                             </Typography>
//                                         </Grid>
//                                         <Grid item xs={6}>
//                                             <Typography>
//                                                 <b>Avg Speed:</b> {formatNumber(avgSpeed)} km/h
//                                             </Typography>
//                                         </Grid>
//                                         <Grid item xs={6}>
//                                             <Typography>
//                                                 <b>Moving:</b> {formatDuration(totalMoving)}
//                                             </Typography>
//                                         </Grid>
//                                         <Grid item xs={6}>
//                                             <Typography>
//                                                 <b>Idling:</b> {formatDuration(totalIdling)}
//                                             </Typography>
//                                         </Grid>
//                                         <Grid item xs={12}>
//                                             <Typography>
//                                                 <b>Violations:</b> {totalViolations}
//                                             </Typography>
//                                         </Grid>
//                                     </Grid>
//                                 </Box>
//                             </CardContent>
//                         </Card>
//                     </Grid>
//                 );
//             })}
//         </Grid>
//     );
// };

// const ViolationsTab = ({ data }) => {
//     const classes = useStyles();
//     const totals = useMemo(() => {
//         const v = { speed: 0, fence: 0, park: 0 };
//         if (!data) return v;
//         data.forEach(r => {
//             v.speed += r.ownerSpeedViolations + r.driverSpeedViolations;
//             v.fence += r.ownerFenceViolations + r.driverFenceViolations;
//             v.park += r.ownerParkViolations + r.driverParkViolations;
//         });
//         return v;
//     }, [data]);
//     return (
//         <Grid container spacing={3} justify="center">
//             <Grid item xs={12} sm={4}>
//                 <Card className={classes.violationsCard}>
//                     <Typography variant="h6">Speed</Typography>
//                     <Typography variant="h3" className={classes.violationValue}>
//                         {totals.speed}
//                     </Typography>
//                 </Card>
//             </Grid>
//             <Grid item xs={12} sm={4}>
//                 <Card className={classes.violationsCard}>
//                     <Typography variant="h6">Fence</Typography>
//                     <Typography variant="h3" className={classes.violationValue}>
//                         {totals.fence}
//                     </Typography>
//                 </Card>
//             </Grid>
//             <Grid item xs={12} sm={4}>
//                 <Card className={classes.violationsCard}>
//                     <Typography variant="h6">Park</Typography>
//                     <Typography variant="h3" className={classes.violationValue}>
//                         {totals.park}
//                     </Typography>
//                 </Card>
//             </Grid>
//         </Grid>
//     );
// };

// const PerformanceTab = ({ data }) => {
//     const classes = useStyles();
//     if (!data || data.length === 0) return <Typography>No performance data.</Typography>;
//     return (
//         <List>
//             {data.map(vehicle => {
//                 const time = vehicle.report.reduce((s, r) => s + r.movingInMinutes + r.idlingInMinutes + r.parkedInMinutes, 0);
//                 const moving = time > 0 ? (vehicle.report.reduce((s, r) => s + r.movingInMinutes, 0) / time) * 100 : 0;
//                 const idling = time > 0 ? (vehicle.report.reduce((s, r) => s + r.idlingInMinutes, 0) / time) * 100 : 0;
//                 const parked = Math.max(0, 100 - moving - idling);
//                 const avgSpeed = vehicle.report.length > 0 ? vehicle.report.reduce((s, r) => s + r.avgSpeedInKmPh, 0) / vehicle.report.length : 0;
//                 const minSpeed = Math.min(...vehicle.report.map(r => r.minSpeedInKmPh).filter(s => s > 0), Infinity);
//                 const maxSpeed = Math.max(...vehicle.report.map(r => r.maxSpeedInKmPh), 0);
//                 return (
//                     <Card key={vehicle.id} className={classes.vehicleListItem}>
//                         <ListItem>
//                             <ListItemText
//                                 primaryTypographyProps={{ variant: "h6" }}
//                                 primary={vehicle.plate}
//                                 secondary={
//                                     <>
//                                         <Typography component="span" variant="body2" color="textPrimary">
//                                             Speed (Avg/Min/Max): {formatNumber(avgSpeed)} / {isFinite(minSpeed) ? formatNumber(minSpeed) : "N/A"} / {formatNumber(maxSpeed)} km/h
//                                         </Typography>
//                                         <br />
//                                         <Typography component="span" variant="body2" color="textSecondary">
//                                             Time: {moving.toFixed(0)}% Moving, {idling.toFixed(0)}% Idling, {parked.toFixed(0)}% Parked
//                                         </Typography>
//                                         <LinearProgress variant="determinate" value={moving} style={{ marginTop: 8 }} />
//                                     </>
//                                 }
//                             />
//                         </ListItem>
//                     </Card>
//                 );
//             })}
//         </List>
//     );
// };

// // MAIN COMPONENT
// const VehiclesReport = props => {
//     const theme = useTheme();
//     const isSmall = useMediaQuery(theme.breakpoints.down("xs"));
//     const classes = useStyles({ isSmall });
//     const notify = useNotify();
//     const [tabIndex, setTabIndex] = useState(0);
//     const [isFilterOpen, setFilterOpen] = useState(false);
//     const [filters, setFilters] = useState(() => ({ days: getInitialState("days", 7), isAllSelected: getInitialState("isAllSelected", true), selectedPlates: getInitialState("selectedPlates", []) }));
//     // const [allVehiclesData, setAllVehiclesData] = useState(null);
//     // const [loading, setLoading] = useState(true);

//     // useEffect(() => {
//     //     const fetchReportData = async () => {
//     //         setLoading(true);
//     //         try {
//     //             const { json } = await httpClient(`${baseiUrl}/vehicles/report?lastStartDay=${filters.days * 2}&lastEndDay=0`, localStorage.getItem("tetherauth"));
//     //             setAllVehiclesData(json);
//     //         } catch (e) {
//     //             console.error("Failed to fetch report data:", e);
//     //             notify("Error: Could not load reports.", { type: "error" });
//     //         } finally {
//     //             setLoading(false);
//     //         }
//     //     };
//     //     fetchReportData();
//     // }, [filters, notify]);

//     // Destructure `data` and rename it to `allVehiclesData` to match your existing code.
//     // Destructure `refetch` as well, which is needed for the refresh button logic.
//     const {
//         data: allVehiclesData,
//         loading,
//         error,
//         refetch,
//     } = useQuery({
//         type: "getList",
//         // 1. Set the correct resource from your useEffect
//         resource: "aggregate",
//         payload: {
//             // Set a high perPage limit to ensure all data is fetched
//             pagination: { page: 1, perPage: 10000 },
//             sort: { field: "plate", order: "ASC" },
//             // 2. This is the filter logic, converted from your useEffect.
//             // useQuery will automatically refetch when `filters.days` changes.
//             filter: {
//                 lastStartDay: filters.days * 2,
//                 lastEndDay: 0,
//             },
//         },
//     });

//     const processedData = useMemo(() => {
//         if (!allVehiclesData) return { trend: [], filteredVehicles: [], kpis: {} };
//         const source = filters.isAllSelected ? allVehiclesData : allVehiclesData.filter(v => filters.selectedPlates.includes(v.plate));
//         const reports = source.flatMap(v => v.report || []);
//         const today = new Date();
//         const trend = [],
//             prev = [];
//         reports.forEach(r => {
//             const p = differenceInCalendarDays(today, parseISO(r.logDay));
//             if (p < filters.days) trend.push(r);
//             else if (p < filters.days * 2) prev.push(r);
//         });
//         const calcKPIs = rl => {
//             if (!rl || rl.length === 0) return { mileage: 0, violations: 0, avgSpeed: 0, idlingTime: 0 };
//             const speedEntries = rl.filter(r => r.avgSpeedInKmPh > 0);
//             return {
//                 mileage: rl.reduce((s, r) => s + r.mileageInMeters, 0) / 1000,
//                 violations: rl.reduce((s, r) => s + r.ownerParkViolations + r.ownerFenceViolations + r.ownerSpeedViolations + r.driverParkViolations + r.driverFenceViolations + r.driverSpeedViolations, 0),
//                 avgSpeed: speedEntries.length > 0 ? speedEntries.reduce((s, r) => s + r.avgSpeedInKmPh, 0) / speedEntries.length : 0,
//                 idlingTime: rl.reduce((s, r) => s + r.idlingInMinutes, 0),
//             };
//         };
//         const currentKPIs = calcKPIs(trend);
//         const previousKPIs = calcKPIs(prev);
//         const chg = (c, p) => (p === 0 ? (c > 0 ? 100 : 0) : ((c - p) / p) * 100);
//         const kpis = {
//             mileage: { c: currentKPIs.mileage, p: chg(currentKPIs.mileage, previousKPIs.mileage) },
//             violations: { c: currentKPIs.violations, p: chg(currentKPIs.violations, previousKPIs.violations) },
//             avgSpeed: { c: currentKPIs.avgSpeed, p: chg(currentKPIs.avgSpeed, previousKPIs.avgSpeed) },
//             idlingTime: { c: currentKPIs.idlingTime, p: chg(currentKPIs.idlingTime, previousKPIs.idlingTime) },
//         };
//         const trendByDay = Object.values(
//             trend.reduce((acc, r) => {
//                 const day = r.logDay.substring(0, 10);
//                 if (!acc[day]) acc[day] = { logDay: day, mileageInMeters: 0, movingInMinutes: 0, idlingInMinutes: 0, ownerSpeedViolations: 0, driverSpeedViolations: 0, ownerFenceViolations: 0, driverFenceViolations: 0, ownerParkViolations: 0, driverParkViolations: 0 };
//                 Object.keys(acc[day]).forEach(key => {
//                     if (typeof r[key] === "number") acc[day][key] += r[key];
//                 });
//                 return acc;
//             }, {})
//         );
//         return { trend: trendByDay, filteredVehicles: source, kpis };
//     }, [allVehiclesData, filters]);

//     const handleApplyFilters = useCallback(f => {
//         setFilters(f);
//         setStateInStorage("days", f.days);
//         setStateInStorage("isAllSelected", f.isAllSelected);
//         setStateInStorage("selectedPlates", f.selectedPlates);
//     }, []);
//     const renderKpiChange = change => {
//         if (isNaN(change)) return null;
//         const pos = change >= 0;
//         return (
//             <Typography variant="body2" className={pos ? classes.kpiChangePositive : classes.kpiChangeNegative}>
//                 {pos ? "+" : ""}
//                 {formatNumber(change)}%
//             </Typography>
//         );
//     };

//     const vehicleCount = filters.isAllSelected ? allVehiclesData?.length || 0 : filters.selectedPlates.length;
//     const dynamicTitle = `Report: ${vehicleCount} Vehicles / ${filters.days} Days`;

//     if (error) return <Error />;

//     return (
//         <div className={classes.root}>
//             <Title title={dynamicTitle} />
//             {/* {loading ? (
//                 <Loading />
//             ) : ( */}
//             <>
//                 <Box display="flex" justifyContent="flex-end" mb={2}>
//                     <Button variant="contained" color="primary" startIcon={<FilterListIcon />} onClick={() => setFilterOpen(true)}>
//                         Filter
//                     </Button>
//                 </Box>
//                 <ReportFilterDialog open={isFilterOpen} onClose={() => setFilterOpen(false)} onApply={handleApplyFilters} allVehicles={allVehiclesData || []} initialFilters={filters} />
//                 <Grid container spacing={isSmall ? 2 : 3} style={{ marginBottom: 16 }}>
//                     <Grid item xs={6} md={3}>
//                         <Card className={classes.kpiCard}>
//                             <CardContent>
//                                 <Typography className={classes.kpiTitle}>Total Distance</Typography>
//                                 <Typography variant="h5" className={classes.kpiValue}>
//                                     {formatNumber(processedData.kpis.mileage?.c)} km
//                                 </Typography>
//                                 {renderKpiChange(processedData.kpis.mileage?.p)}
//                             </CardContent>
//                         </Card>
//                     </Grid>
//                     <Grid item xs={6} md={3}>
//                         <Card className={classes.kpiCard}>
//                             <CardContent>
//                                 <Typography className={classes.kpiTitle}>Total Violations</Typography>
//                                 <Typography variant="h5" className={classes.kpiValue}>
//                                     {Math.round(processedData.kpis.violations?.c || 0)}
//                                 </Typography>
//                                 {renderKpiChange(processedData.kpis.violations?.p)}
//                             </CardContent>
//                         </Card>
//                     </Grid>
//                     <Grid item xs={6} md={3}>
//                         <Card className={classes.kpiCard}>
//                             <CardContent>
//                                 <Typography className={classes.kpiTitle}>Average Speed</Typography>
//                                 <Typography variant="h5" className={classes.kpiValue}>
//                                     {formatNumber(processedData.kpis.avgSpeed?.c)} km/h
//                                 </Typography>
//                                 {renderKpiChange(processedData.kpis.avgSpeed?.p)}
//                             </CardContent>
//                         </Card>
//                     </Grid>
//                     <Grid item xs={6} md={3}>
//                         <Card className={classes.kpiCard}>
//                             <CardContent>
//                                 <Typography className={classes.kpiTitle}>Idling Time</Typography>
//                                 <Typography variant="h5" className={classes.kpiValue}>
//                                     {formatDuration(processedData.kpis.idlingTime?.c)}
//                                 </Typography>
//                                 {renderKpiChange(processedData.kpis.idlingTime?.p)}
//                             </CardContent>
//                         </Card>
//                     </Grid>
//                 </Grid>
//                 <Paper>
//                     <Tabs value={tabIndex} onChange={(e, val) => setTabIndex(val)} indicatorColor="primary" textColor="primary" variant={isSmall ? "scrollable" : "standard"} scrollButtons="auto" centered={!isSmall}>
//                         <Tab label="Overview" className={isSmall ? classes.mobileTab : ""} />
//                         <Tab label="Vehicles" className={isSmall ? classes.mobileTab : ""} />
//                         <Tab label="Violations" className={isSmall ? classes.mobileTab : ""} />
//                         <Tab label="Performance" className={isSmall ? classes.mobileTab : ""} />
//                     </Tabs>
//                     <Box className={classes.tabPanel}>
//                         {tabIndex === 0 && <OverviewTab data={processedData.trend} isSmall={isSmall} />}
//                         {tabIndex === 1 && <VehiclesTab data={processedData.filteredVehicles} />}
//                         {tabIndex === 2 && <ViolationsTab data={processedData.trend} />}
//                         {tabIndex === 3 && <PerformanceTab data={processedData.filteredVehicles} />}
//                     </Box>
//                 </Paper>
//             </>
//             {/* // )} */}
//         </div>
//     );
// };

// export default VehiclesReport;
import React, { useState, useEffect, useMemo, useCallback } from "react";
import { Title, useNotify, useQuery, Error } from "react-admin";
import { Grid, Card, CardContent, Typography, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Checkbox, FormControlLabel, List, ListItem, ListItemIcon, ListItemText, Tabs, Tab, Box, Paper, LinearProgress, makeStyles, useTheme, useMediaQuery } from "@material-ui/core";
import FilterListIcon from "@material-ui/icons/FilterList";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, BarChart, Bar } from "recharts";
import { differenceInCalendarDays, parseISO, format, subDays, addDays } from "date-fns";
import { httpClient } from "../api/dataProvider"; // UPDATE THIS PATH if needed
import { baseiUrl } from "../utils/constants"; // UPDATE THIS PATH if needed

// STYLING
const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(2),
    },
    kpiCard: {
        height: "100%",
    },
    kpiTitle: {
        color: theme.palette.text.secondary,
    },
    kpiValue: {
        fontWeight: "bold",
    },
    kpiChangePositive: {
        color: theme.palette.success.main,
    },
    kpiChangeNegative: {
        color: theme.palette.error.main,
    },
    chartContainer: {
        height: 300,
    },
    mobileTab: {
        fontSize: "0.5rem",
        minWidth: "auto",
        maxWidth: "100%",
        // padding: theme.spacing(1, 2),
    },
    tabPanel: {
        padding: props => (props.isSmall ? theme.spacing(1) : theme.spacing(2)),
    },
    vehicleListItem: {
        marginBottom: theme.spacing(2),
    },
    violationsCard: {
        textAlign: "center",
        padding: theme.spacing(3),
    },
    violationValue: {
        fontWeight: "bold",
        marginTop: theme.spacing(1),
    },
}));

// UTILITY FUNCTIONS
const formatNumber = (num = 0, digits = 1) => num.toLocaleString(undefined, { minimumFractionDigits: digits, maximumFractionDigits: digits });
const formatDuration = (totalMinutes = 0) => {
    if (isNaN(totalMinutes) || totalMinutes <= 0) return "0m";
    const h = Math.floor(totalMinutes / 60);
    const m = Math.round(totalMinutes % 60);
    return `${h > 0 ? `${h}h ` : ""}${m > 0 ? `${m}m` : ""}`.trim() || "0m";
};
const getInitialState = (key, dv) => {
    try {
        const i = localStorage.getItem(`tether_report_${key}`);
        return i ? JSON.parse(i) : dv;
    } catch (e) {
        return dv;
    }
};
const setStateInStorage = (key, v) => {
    try {
        localStorage.setItem(`tether_report_${key}`, JSON.stringify(v));
    } catch (e) {}
};

// CHILD COMPONENTS
const ReportFilterDialog = ({ open, onClose, onApply, allVehicles, initialFilters }) => {
    const [startDate, setStartDate] = useState(initialFilters.startDate);
    const [endDate, setEndDate] = useState(initialFilters.endDate);
    const [isAllSelected, setAllSelected] = useState(initialFilters.isAllSelected);
    const [selectedPlates, setSelectedPlates] = useState(initialFilters.selectedPlates);

    useEffect(() => {
        if (open) {
            setStartDate(initialFilters.startDate);
            setEndDate(initialFilters.endDate);
            setAllSelected(initialFilters.isAllSelected);
            setSelectedPlates(initialFilters.selectedPlates);
        }
    }, [initialFilters, open]);

    const handleToggleVehicle = plate => setSelectedPlates(p => (p.includes(plate) ? p.filter(i => i !== plate) : [...p, plate]));

    const handleStartDateChange = e => {
        const newStartDate = e.target.value;
        setStartDate(newStartDate);

        // If the new start date is after the current end date, update the end date
        if (newStartDate && endDate && parseISO(newStartDate) > parseISO(endDate)) {
            setEndDate(format(addDays(parseISO(newStartDate), 1), "yyyy-MM-dd"));
        }
    };

    const handleEndDateChange = e => {
        const newEndDate = e.target.value;
        setEndDate(newEndDate);

        // If the new end date is before the current start date, update the start date
        if (newEndDate && startDate && parseISO(newEndDate) < parseISO(startDate)) {
            setStartDate(format(subDays(parseISO(newEndDate), 1), "yyyy-MM-dd"));
        }
    };

    const handleApply = () => {
        onApply({ startDate, endDate, isAllSelected, selectedPlates });
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Filter Report</DialogTitle>
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <TextField autoFocus margin="dense" label="Start Date" type="date" fullWidth value={startDate} onChange={handleStartDateChange} InputLabelProps={{ shrink: true }} />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField margin="dense" label="End Date" type="date" fullWidth value={endDate} onChange={handleEndDateChange} InputLabelProps={{ shrink: true }} />
                    </Grid>
                </Grid>
                <FormControlLabel control={<Checkbox checked={isAllSelected} onChange={e => setAllSelected(e.target.checked)} />} label="All Vehicles" />
                {!isAllSelected && (
                    <Paper variant="outlined" style={{ maxHeight: 300, overflow: "auto" }}>
                        <List dense>
                            {(allVehicles || []).map(v => (
                                <ListItem key={v.id} button onClick={() => handleToggleVehicle(v.plate)}>
                                    <ListItemIcon>
                                        <Checkbox edge="start" checked={selectedPlates.includes(v.plate)} tabIndex={-1} />
                                    </ListItemIcon>
                                    <ListItemText primary={v.plate} secondary={v.tag || ""} />
                                </ListItem>
                            ))}
                        </List>
                    </Paper>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button onClick={handleApply} color="primary" variant="contained">
                    Go
                </Button>
            </DialogActions>
        </Dialog>
    );
};

const OverviewTab = ({ data, isSmall }) => {
    const classes = useStyles();
    const theme = useTheme();

    // Calculate chart data for all charts at once, ensuring robustness against null/undefined values.
    const chartData = useMemo(() => {
        if (!data) return [];
        const validData = data.filter(r => r && r.logDay); // Ensure data point and logDay exist

        return validData
            .sort((a, b) => new Date(a.logDay) - new Date(b.logDay))
            .map(r => {
                try {
                    return {
                        name: format(parseISO(r.logDay), isSmall ? "M/d" : "MMM d"),
                        "Distance (km)": parseFloat(((r.mileageInMeters || 0) / 1000).toFixed(1)),
                        "Idle (hr)": (r.idlingInMinutes || 0) / 60,
                        "Driven (hr)": (r.movingInMinutes || 0) / 60,
                        "Speed Violations": (r.ownerSpeedViolations || 0) + (r.driverSpeedViolations || 0),
                        "Fence Violations": (r.ownerFenceViolations || 0) + (r.driverFenceViolations || 0),
                    };
                } catch (error) {
                    // This will skip any entries with an invalid date format
                    return null;
                }
            })
            .filter(Boolean); // Remove any null entries that failed to parse
    }, [data, isSmall]);

    return (
        <Grid container spacing={4}>
            {/* 1. Daily Mileage Chart */}
            <Grid item xs={12} md={6}>
                <Typography variant="h6" gutterBottom align="center">
                    Daily Mileage (km)
                </Typography>
                <div className={classes.chartContainer}>
                    <ResponsiveContainer>
                        <LineChart data={chartData} margin={{ top: 5, right: 20, left: -10, bottom: 5 }}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="name" tick={{ fontSize: isSmall ? 10 : 12 }} />
                            <YAxis tick={{ fontSize: isSmall ? 10 : 12 }} />
                            <Tooltip formatter={value => [`${value} km`, null]} />
                            <Legend />
                            <Line type="monotone" dataKey="Distance (km)" stroke={theme.palette.primary.main} strokeWidth={2} />
                        </LineChart>
                    </ResponsiveContainer>
                </div>
            </Grid>

            {/* 2. Idle vs. Driven Time Chart */}
            <Grid item xs={12} md={6}>
                <Typography variant="h6" gutterBottom align="center">
                    Idle vs. Driven Time (Hours)
                </Typography>
                <div className={classes.chartContainer}>
                    <ResponsiveContainer>
                        <BarChart data={chartData} margin={{ top: 5, right: 20, left: -10, bottom: 5 }}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="name" tick={{ fontSize: isSmall ? 10 : 12 }} />
                            <YAxis tick={{ fontSize: isSmall ? 10 : 12 }} tickFormatter={value => `${Math.round(value)}h`} />
                            <Tooltip formatter={(value, name) => [`${parseFloat(value).toFixed(1)}h`, name]} />
                            <Legend />
                            <Bar dataKey="Idle (hr)" fill={theme.palette.secondary.light} />
                            <Bar dataKey="Driven (hr)" fill={theme.palette.success.light} />
                        </BarChart>
                    </ResponsiveContainer>
                </div>
            </Grid>

            {/* 3. Speed Violations Chart */}
            <Grid item xs={12} md={6}>
                <Typography variant="h6" gutterBottom align="center">
                    Speed Violations
                </Typography>
                <div className={classes.chartContainer}>
                    <ResponsiveContainer>
                        <BarChart data={chartData} margin={{ top: 5, right: 20, left: -10, bottom: 5 }}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="name" tick={{ fontSize: isSmall ? 10 : 12 }} />
                            <YAxis allowDecimals={false} tick={{ fontSize: isSmall ? 10 : 12 }} />
                            <Tooltip />
                            <Legend />
                            <Bar dataKey="Speed Violations" fill={theme.palette.error.main} />
                        </BarChart>
                    </ResponsiveContainer>
                </div>
            </Grid>

            {/* 4. Fence Violations Chart */}
            <Grid item xs={12} md={6}>
                <Typography variant="h6" gutterBottom align="center">
                    Fence Violations
                </Typography>
                <div className={classes.chartContainer}>
                    <ResponsiveContainer>
                        <BarChart data={chartData} margin={{ top: 5, right: 20, left: -10, bottom: 5 }}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="name" tick={{ fontSize: isSmall ? 10 : 12 }} />
                            <YAxis allowDecimals={false} tick={{ fontSize: isSmall ? 10 : 12 }} />
                            <Tooltip />
                            <Legend />
                            <Bar dataKey="Fence Violations" fill={theme.palette.warning.main} />
                        </BarChart>
                    </ResponsiveContainer>
                </div>
            </Grid>
        </Grid>
    );
};

const VehiclesTab = ({ data }) => {
    const classes = useStyles();
    if (!data || data.length === 0) return <Typography>No vehicle data to display.</Typography>;
    return (
        <Grid container spacing={2}>
            {data.map(vehicle => {
                const totalMileage = vehicle.report.reduce((s, r) => s + r.mileageInMeters, 0) / 1000;
                const totalMoving = vehicle.report.reduce((s, r) => s + r.movingInMinutes, 0);
                const totalIdling = vehicle.report.reduce((s, r) => s + r.idlingInMinutes, 0);
                const avgSpeed = vehicle.report.length > 0 ? vehicle.report.reduce((s, r) => s + r.avgSpeedInKmPh, 0) / vehicle.report.length : 0;
                const totalViolations = vehicle.report.reduce((s, r) => s + r.ownerParkViolations + r.ownerFenceViolations + r.ownerSpeedViolations + r.driverParkViolations + r.driverFenceViolations + r.driverSpeedViolations, 0);
                return (
                    <Grid item xs={12} sm={6} md={4} key={vehicle.id}>
                        <Card className={classes.vehicleListItem}>
                            <CardContent>
                                <Typography variant="h6">{vehicle.plate}</Typography>
                                <Typography color="textSecondary" gutterBottom>
                                    {vehicle.tag || `${vehicle.brand || ""} ${vehicle.model || ""}`}
                                </Typography>
                                <Box mt={2}>
                                    <Grid container spacing={1}>
                                        <Grid item xs={6}>
                                            <Typography>
                                                <b>Distance:</b> {formatNumber(totalMileage)} km
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Typography>
                                                <b>Avg Speed:</b> {formatNumber(avgSpeed)} km/h
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Typography>
                                                <b>Moving:</b> {formatDuration(totalMoving)}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Typography>
                                                <b>Idling:</b> {formatDuration(totalIdling)}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography>
                                                <b>Violations:</b> {totalViolations}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>
                );
            })}
        </Grid>
    );
};

const ViolationsTab = ({ data }) => {
    const classes = useStyles();
    const totals = useMemo(() => {
        const v = { speed: 0, fence: 0, park: 0 };
        if (!data) return v;
        data.forEach(r => {
            v.speed += r.ownerSpeedViolations + r.driverSpeedViolations;
            v.fence += r.ownerFenceViolations + r.driverFenceViolations;
            v.park += r.ownerParkViolations + r.driverParkViolations;
        });
        return v;
    }, [data]);
    return (
        <Grid container spacing={3} justify="center">
            <Grid item xs={12} sm={4}>
                <Card className={classes.violationsCard}>
                    <Typography variant="h6">Speed</Typography>
                    <Typography variant="h3" className={classes.violationValue}>
                        {totals.speed}
                    </Typography>
                </Card>
            </Grid>
            <Grid item xs={12} sm={4}>
                <Card className={classes.violationsCard}>
                    <Typography variant="h6">Fence</Typography>
                    <Typography variant="h3" className={classes.violationValue}>
                        {totals.fence}
                    </Typography>
                </Card>
            </Grid>
            <Grid item xs={12} sm={4}>
                <Card className={classes.violationsCard}>
                    <Typography variant="h6">Park</Typography>
                    <Typography variant="h3" className={classes.violationValue}>
                        {totals.park}
                    </Typography>
                </Card>
            </Grid>
        </Grid>
    );
};

const PerformanceTab = ({ data }) => {
    const classes = useStyles();
    if (!data || data.length === 0) return <Typography>No performance data.</Typography>;
    return (
        <List>
            {data.map(vehicle => {
                const time = vehicle.report.reduce((s, r) => s + r.movingInMinutes + r.idlingInMinutes + r.parkedInMinutes, 0);
                const moving = time > 0 ? (vehicle.report.reduce((s, r) => s + r.movingInMinutes, 0) / time) * 100 : 0;
                const idling = time > 0 ? (vehicle.report.reduce((s, r) => s + r.idlingInMinutes, 0) / time) * 100 : 0;
                const parked = Math.max(0, 100 - moving - idling);
                const avgSpeed = vehicle.report.length > 0 ? vehicle.report.reduce((s, r) => s + r.avgSpeedInKmPh, 0) / vehicle.report.length : 0;
                const minSpeed = Math.min(...vehicle.report.map(r => r.minSpeedInKmPh).filter(s => s > 0), Infinity);
                const maxSpeed = Math.max(...vehicle.report.map(r => r.maxSpeedInKmPh), 0);
                return (
                    <Card key={vehicle.id} className={classes.vehicleListItem}>
                        <ListItem>
                            <ListItemText
                                primaryTypographyProps={{ variant: "h6" }}
                                primary={vehicle.plate}
                                secondary={
                                    <>
                                        <Typography component="span" variant="body2" color="textPrimary">
                                            Speed (Avg/Min/Max): {formatNumber(avgSpeed)} / {isFinite(minSpeed) ? formatNumber(minSpeed) : "N/A"} / {formatNumber(maxSpeed)} km/h
                                        </Typography>
                                        <br />
                                        <Typography component="span" variant="body2" color="textSecondary">
                                            Time: {moving.toFixed(0)}% Moving, {idling.toFixed(0)}% Idling, {parked.toFixed(0)}% Parked
                                        </Typography>
                                        <LinearProgress variant="determinate" value={moving} style={{ marginTop: 8 }} />
                                    </>
                                }
                            />
                        </ListItem>
                    </Card>
                );
            })}
        </List>
    );
};

// MAIN COMPONENT
const VehiclesReport = props => {
    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.down("xs"));
    const classes = useStyles({ isSmall });
    const [tabIndex, setTabIndex] = useState(0);
    const [isFilterOpen, setFilterOpen] = useState(false);

    const [filters, setFilters] = useState(() => {
        const today = new Date();
        const defaultEndDate = format(today, "yyyy-MM-dd");
        const defaultStartDate = format(subDays(today, 6), "yyyy-MM-dd");

        return {
            startDate: getInitialState("startDate", defaultStartDate),
            endDate: getInitialState("endDate", defaultEndDate),
            isAllSelected: getInitialState("isAllSelected", true),
            selectedPlates: getInitialState("selectedPlates", []),
        };
    });

    // Calculate API parameters based on the selected date range
    const apiParams = useMemo(() => {
        const today = new Date();
        const start = parseISO(filters.startDate);
        const end = parseISO(filters.endDate);

        // Fallback for invalid dates
        if (isNaN(start.getTime()) || isNaN(end.getTime()) || start > end) {
            return { lastStartDay: 14, lastEndDay: 0 };
        }

        const duration = differenceInCalendarDays(end, start) + 1; // Number of days in the selected range
        const lastEndDay = differenceInCalendarDays(today, end);
        const lastStartDay = lastEndDay + duration * 2 - 1;

        return {
            lastStartDay: Math.max(0, lastStartDay), // Ensure it's not negative
            lastEndDay: Math.max(0, lastEndDay),
        };
    }, [filters.startDate, filters.endDate]);

    const {
        data: allVehiclesData,
        loading,
        error,
    } = useQuery({
        type: "getList",
        resource: "aggregate",
        payload: {
            pagination: { page: 1, perPage: 10000 },
            sort: { field: "plate", order: "ASC" },
            filter: {
                ...apiParams,
            },
        },
    });

    const processedData = useMemo(() => {
        if (!allVehiclesData) return { trend: [], filteredVehicles: [], kpis: {} };
        const source = filters.isAllSelected ? allVehiclesData : allVehiclesData.filter(v => filters.selectedPlates.includes(v.plate));
        const reports = source.flatMap(v => v.report || []);

        const startFilterDate = parseISO(filters.startDate);
        const endFilterDate = parseISO(filters.endDate);

        const trend = [],
            prev = [];

        reports.forEach(r => {
            try {
                const logDate = parseISO(r.logDay);
                // Check if the log date is within the selected range for the 'trend' data
                if (logDate >= startFilterDate && logDate <= endFilterDate) {
                    trend.push(r);
                } else {
                    // All other data fetched belongs to the previous period for comparison
                    prev.push(r);
                }
            } catch (e) {
                // Ignore entries with invalid date formats
            }
        });

        const calcKPIs = rl => {
            if (!rl || rl.length === 0) return { mileage: 0, violations: 0, avgSpeed: 0, idlingTime: 0 };
            const speedEntries = rl.filter(r => r.avgSpeedInKmPh > 0);
            return {
                mileage: rl.reduce((s, r) => s + r.mileageInMeters, 0) / 1000,
                violations: rl.reduce((s, r) => s + r.ownerParkViolations + r.ownerFenceViolations + r.ownerSpeedViolations + r.driverParkViolations + r.driverFenceViolations + r.driverSpeedViolations, 0),
                avgSpeed: speedEntries.length > 0 ? speedEntries.reduce((s, r) => s + r.avgSpeedInKmPh, 0) / speedEntries.length : 0,
                idlingTime: rl.reduce((s, r) => s + r.idlingInMinutes, 0),
            };
        };

        const currentKPIs = calcKPIs(trend);
        const previousKPIs = calcKPIs(prev);
        const chg = (c, p) => (p === 0 ? (c > 0 ? 100 : 0) : ((c - p) / p) * 100);
        const kpis = {
            mileage: { c: currentKPIs.mileage, p: chg(currentKPIs.mileage, previousKPIs.mileage) },
            violations: { c: currentKPIs.violations, p: chg(currentKPIs.violations, previousKPIs.violations) },
            avgSpeed: { c: currentKPIs.avgSpeed, p: chg(currentKPIs.avgSpeed, previousKPIs.avgSpeed) },
            idlingTime: { c: currentKPIs.idlingTime, p: chg(currentKPIs.idlingTime, previousKPIs.idlingTime) },
        };
        const trendByDay = Object.values(
            trend.reduce((acc, r) => {
                const day = r.logDay.substring(0, 10);
                if (!acc[day]) acc[day] = { logDay: day, mileageInMeters: 0, movingInMinutes: 0, idlingInMinutes: 0, ownerSpeedViolations: 0, driverSpeedViolations: 0, ownerFenceViolations: 0, driverFenceViolations: 0, ownerParkViolations: 0, driverParkViolations: 0 };
                Object.keys(acc[day]).forEach(key => {
                    if (typeof r[key] === "number") acc[day][key] += r[key];
                });
                return acc;
            }, {})
        );
        return { trend: trendByDay, filteredVehicles: source, kpis };
    }, [allVehiclesData, filters]);

    const handleApplyFilters = useCallback(f => {
        setFilters(f);
        setStateInStorage("startDate", f.startDate);
        setStateInStorage("endDate", f.endDate);
        setStateInStorage("isAllSelected", f.isAllSelected);
        setStateInStorage("selectedPlates", f.selectedPlates);
    }, []);

    const renderKpiChange = change => {
        if (isNaN(change)) return null;
        const pos = change >= 0;
        return (
            <Typography variant="body2" className={pos ? classes.kpiChangePositive : classes.kpiChangeNegative}>
                {pos ? "+" : ""}
                {formatNumber(change)}%
            </Typography>
        );
    };

    const vehicleCount = filters.isAllSelected ? allVehiclesData?.length || 0 : filters.selectedPlates.length;

    let dynamicTitle = "Vehicle Report";
    try {
        const start = format(parseISO(filters.startDate), "MMM d");
        const end = format(parseISO(filters.endDate), "MMM d, yyyy");
        dynamicTitle = `${vehicleCount} Vehicles / ${start} - ${end}`;
    } catch (e) {
        // Fallback title if dates are invalid
    }

    // if (loading) return <LinearProgress />;
    if (error) return <Error />;

    return (
        <div className={classes.root}>
            <Title title={dynamicTitle} />
            <>
                <Box display="flex" justifyContent="flex-end" mb={2}>
                    <Button variant="contained" color="primary" startIcon={<FilterListIcon />} onClick={() => setFilterOpen(true)}>
                        Filter
                    </Button>
                </Box>
                <ReportFilterDialog open={isFilterOpen} onClose={() => setFilterOpen(false)} onApply={handleApplyFilters} allVehicles={allVehiclesData || []} initialFilters={filters} />
                <Grid container spacing={isSmall ? 2 : 3} style={{ marginBottom: 16 }}>
                    <Grid item xs={6} md={3}>
                        <Card className={classes.kpiCard}>
                            <CardContent>
                                <Typography className={classes.kpiTitle}>Total Distance</Typography>
                                <Typography variant="h5" className={classes.kpiValue}>
                                    {formatNumber(processedData.kpis.mileage?.c)} km
                                </Typography>
                                {renderKpiChange(processedData.kpis.mileage?.p)}
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={6} md={3}>
                        <Card className={classes.kpiCard}>
                            <CardContent>
                                <Typography className={classes.kpiTitle}>Total Violations</Typography>
                                <Typography variant="h5" className={classes.kpiValue}>
                                    {Math.round(processedData.kpis.violations?.c || 0)}
                                </Typography>
                                {renderKpiChange(processedData.kpis.violations?.p)}
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={6} md={3}>
                        <Card className={classes.kpiCard}>
                            <CardContent>
                                <Typography className={classes.kpiTitle}>Average Speed</Typography>
                                <Typography variant="h5" className={classes.kpiValue}>
                                    {formatNumber(processedData.kpis.avgSpeed?.c)} km/h
                                </Typography>
                                {renderKpiChange(processedData.kpis.avgSpeed?.p)}
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={6} md={3}>
                        <Card className={classes.kpiCard}>
                            <CardContent>
                                <Typography className={classes.kpiTitle}>Idling Time</Typography>
                                <Typography variant="h5" className={classes.kpiValue}>
                                    {formatDuration(processedData.kpis.idlingTime?.c)}
                                </Typography>
                                {renderKpiChange(processedData.kpis.idlingTime?.p)}
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
                <Paper>
                    <Tabs value={tabIndex} onChange={(e, val) => setTabIndex(val)} indicatorColor="primary" textColor="primary" variant={isSmall ? "scrollable" : "standard"} scrollButtons="auto" centered={!isSmall}>
                        <Tab label="Overview" className={isSmall ? classes.mobileTab : ""} />
                        <Tab label="Vehicles" className={isSmall ? classes.mobileTab : ""} />
                        <Tab label="Violations" className={isSmall ? classes.mobileTab : ""} />
                        <Tab label="Performance" className={isSmall ? classes.mobileTab : ""} />
                    </Tabs>
                    <Box className={classes.tabPanel}>
                        {tabIndex === 0 && <OverviewTab data={processedData.trend} isSmall={isSmall} />}
                        {tabIndex === 1 && <VehiclesTab data={processedData.filteredVehicles} />}
                        {tabIndex === 2 && <ViolationsTab data={processedData.trend} />}
                        {tabIndex === 3 && <PerformanceTab data={processedData.filteredVehicles} />}
                    </Box>
                </Paper>
            </>
        </div>
    );
};

export default VehiclesReport;
